
export const disabledServiceWorkerUrls = [
    "vodapay.quickbus.com",
    "vodapay-dev.quickbus.com",
    "vodapay-staging.quickbus.com",
    "jumia.quickbus.com",
    "jumia-dev.quickbus.com"
]

export const loadCustomManifestAndStyle = () => {
    const hostname = window.location.hostname;
    const manifestUrl = `https://qb-whitelabel.s3.af-south-1.amazonaws.com/${hostname}/manifest.webmanifest`;
    const styleUrl = `https://qb-whitelabel.s3.af-south-1.amazonaws.com/${hostname}/custom.css`;
  
    // Set or create manifest link
    let manifestEl = document.getElementById('manifest') as HTMLLinkElement;
    if (!manifestEl) {
      manifestEl = document.createElement('link');
      manifestEl.rel = 'manifest';
      manifestEl.id = 'manifest';
      document.head.appendChild(manifestEl);
    }
    manifestEl.href = manifestUrl;
  
    // Set or create custom style link
    let styleEl = document.getElementById('custom_style') as HTMLLinkElement;
    if (!styleEl) {
      styleEl = document.createElement('link');
      styleEl.rel = 'stylesheet';
      styleEl.id = 'custom_style';
      document.head.appendChild(styleEl);
    }
    styleEl.href = styleUrl;
  };
  